var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreditCardRevenueWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3.75h-15A1.25 1.25 0 001.25 5v10a1.25 1.25 0 001.25 1.25h15A1.25 1.25 0 0018.75 15V5a1.25 1.25 0 00-1.25-1.25zm-6.875 10h-1.25a.625.625 0 110-1.25h1.25a.624.624 0 110 1.25zm5 0h-2.5a.624.624 0 110-1.25h2.5a.624.624 0 110 1.25zM2.5 6.875V5h15v1.875h-15z",
    fill: "#fff"
  })));
}

export default SvgCreditCardRevenueWhite;